import api from 'Application/api/api';

const changeTemplateName = (templateId, name, cancelToken = null) =>
    api.post(
        `project-manager/templates/${templateId}/change-name`,
        {
            name,
        },
        { cancelToken },
    );

export default changeTemplateName;
